namespace GeniuzPOS.Purchase {
    export interface ReportPendingPRRow {
        SysDocNo?: string;
        UseFg?: usefg;
        DocNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        SupplierId?: string;
        SupplName?: string;
        ShipId?: string;
        ShipName?: string;
        ShipDate?: string;
        PayTermCode?: string;
        WhsId?: string;
        PurOrderAmt?: number;
        Remark?: string;
        DtList?: ReportPendingPRDtRow[];
    }

    export namespace ReportPendingPRRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Purchase.ReportPendingPR';
        export const lookupKey = 'Purchase.ReportPendingPR';

        export function getLookup(): Q.Lookup<ReportPendingPRRow> {
            return Q.getLookup<ReportPendingPRRow>('Purchase.ReportPendingPR');
        }
        export const deletePermission = '5Purchase:รายงาน:รายงานใบขอสั่งซื้อคงค้าง:View';
        export const insertPermission = '5Purchase:รายงาน:รายงานใบขอสั่งซื้อคงค้าง:View';
        export const readPermission = '5Purchase:รายงาน:รายงานใบขอสั่งซื้อคงค้าง:View';
        export const updatePermission = '5Purchase:รายงาน:รายงานใบขอสั่งซื้อคงค้าง:View';

        export declare const enum Fields {
            SysDocNo = "SysDocNo",
            UseFg = "UseFg",
            DocNo = "DocNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            SupplierId = "SupplierId",
            SupplName = "SupplName",
            ShipId = "ShipId",
            ShipName = "ShipName",
            ShipDate = "ShipDate",
            PayTermCode = "PayTermCode",
            WhsId = "WhsId",
            PurOrderAmt = "PurOrderAmt",
            Remark = "Remark",
            DtList = "DtList"
        }
    }
}
